module.exports = __webpack_public_path__ + "media/application/images/icons/mobile-arrow-778b27ed7b2d262de62230953ec80bc8.svg";